<template>
  <layout titlePage="Transferir para conta" :route="{ name: 'carteira' }">
    <SubmenuBack v-if="hasToShowNewMenu" />
    <div class="container has-text-centered">
      <div
        class="columns columns--full is-vcentered is-centered wallet-withdraw"
      >
        <div class="column is-half" style="max-width: 448px">
          <div class="wallet-withdraw__transfer-pix">
            <p class="wallet-withdraw__title">
              <b>Transferência por PIX</b>
            </p>

            <p class="wallet-withdraw__subtitle" v-if="disablePPandKeyPix">
              Transfira <b>gratuitamente</b> para sua conta bancária e receba em
              até <b>1 hora</b>.
            </p>

            <div class="wallet-withdraw__info-box">
              <div ref="withdrawalTime" class="wallet-withdraw__info-box--time">
                <img :src="clock" />
                <div>
                  <p class="title">Horários de transferência</p>
                  <p>
                    Para a sua segurança, as
                    <strong
                      >transferências via PIX estão disponíveis todos os dias
                      das <span>10h00 às 18h00</span>
                    </strong>
                    - horário de Brasília.
                  </p>
                  <p class="attention">
                    Não é possível solicitar saques fora desse horário.
                  </p>
                </div>
              </div>

              <div class="wallet-withdraw__info-box--alert">
                <span class="icon">
                  <base-icon
                    width="24px"
                    height="24px"
                    :name="'alert-yellow'"
                  />
                </span>
                <p class="has-text-left">
                  As transferências são <b>gratuitas</b> e poderão levar até
                  <span>2 horas</span> para serem concluídas.
                </p>
              </div>
              <hr />
            </div>

            <div v-if="pixKeysAccount" class="has-text-left">
              <p class="wallet-withdraw__info-title">
                Minhas chaves cadastradas
              </p>
              <p>
                Cadastre até duas chaves Pix para recebimento dos seus
                presentes.
              </p>
            </div>

            <div
              class="accounts-registered"
              v-for="(pixKey, index) in pixKeysAccount"
              :key="index"
            >
              <div
                @click="withdrawWithPix(pixKey.data)"
                class="accounts-registered--item"
                :class="{
                  disabled:
                    btnWidthdrawNotAvailable &&
                    pixKey.data.enabled_to_use != 0 &&
                    pixKey.data.verified != 0,
                }"
              >
                <BoxPixKeyRegistered :content="pixKey" />
              </div>
            </div>
            <hr v-if="pixKeysAccount && !hasTwoPixKeysValid" />
            <router-link
              :to="{
                name: 'carteira-escolher-conta',
                params: { transfer: 'pix' },
              }"
            >
              <BoxButtonCreatePixKey v-if="!hasTwoPixKeysValid" />
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <ModalPixKeyInvalid ref="modalPixKeyInvalid" />
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import SubmenuBack from '@/layouts/parts/SubmenuBack.vue'
import BoxPixKeyRegistered from '@/components/Wallet/Pix/List/BoxPixKeyRegistered.vue'
import BoxButtonCreatePixKey from '@/components/Wallet/Pix/Register/BoxButtonCreatePixKey.vue'
import ModalPixKeyInvalid from '@/components/Wallet/Pix/Modals/ModalPixKeyInvalid.vue'

import loadingViewMixin from '@/mixins/loadingViewMixin'
import walletDataMixin from '@/mixins/walletDataMixin'

import WalletApi from '@/lib/api/Wallet'

import imgsettings from '@/assets/img/gear-icon.png'
import clock from '@/assets/img/clock-blue.png'

export default {
  mixins: [loadingViewMixin, walletDataMixin],

  components: {
    layout,
    SubmenuBack,
    BoxPixKeyRegistered,
    BoxButtonCreatePixKey,
    ModalPixKeyInvalid,
  },

  computed: {
    userDataTransfer: {
      get() {
        return this.$store.state.wallet.userDataTransfer
      },
      set(payload) {
        this.$store.dispatch('setSelectedAccountTransfer', payload)
      },
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    wedId() {
      return this.logonToken?.token_payload?.wed_id
    },

    pixKeysAccount: {
      get() {
        return this.$store.state.wallet.pixKeysAccount
      },
      set(payload) {
        this.$store.dispatch('setAccountsPix', payload)
      },
    },

    listPixKeys: {
      get() {
        return this.$store.state.wallet.listPixKey
      },
      set(payload) {
        this.$store.dispatch('setListPixKey', payload)
      },
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    hasToShowNewMenu() {
      return this.wedSiteInfo.site_menu_versao ? true : false
    },

    hasTwoPixKeysValid() {
      if (!this.pixKeysAccount) return false
      const filtered = this.pixKeysAccount.filter((pixKey) => {
        return pixKey.data.verified !== 3
      })

      return filtered.length >= 2 ? true : false
    },

    allowInternalWithdraw() {
      const internalWedsites = [64254, 771343, 754614, 206137]
      const isInternalWedsite = internalWedsites.includes(Number(this.wedId))

      if (process.env.VUE_APP_ENV !== 'production' || isInternalWedsite)
        return true
      return false
    },
  },

  watch: {
    walletSummary() {
      this.withdrawIsAvailable(this.walletSummary.meta.created_date)

      if (this.walletSummary.loading || !this.walletSummary.owner_cpf) {
        this.$router.push({ name: 'carteira' })
      }
    },
  },

  mounted() {
    this.updateInformation()

    if (!this.walletSummary.loading)
      this.withdrawIsAvailable(this.walletSummary.meta.created_date)

    this.getOwnerPixKeys()
  },

  data() {
    return {
      btnWidthdrawNotAvailable: true,
      disablePPandKeyPix: false,
      showInformation: false,
      imgsettings,
      clock,
      dateFormated: null,
    }
  },

  methods: {
    updateInformation() {
      const dataNow = new Date().getTime()
      dataNow >= 1634900400000 ? (this.showInformation = true) : ''
    },

    withdrawIsAvailable(data) {
      if (this.allowInternalWithdraw) {
        this.btnWidthdrawNotAvailable = false
      } else {
        const splitTime = data.split(' ')
        const time = splitTime[1].split(':')

        if (parseInt(time[0]) >= 10 && parseInt(time[0]) <= 17) {
          this.btnWidthdrawNotAvailable = false
        } else {
          this.btnWidthdrawNotAvailable = true
        }
      }
    },

    getUserPixKeys(data) {
      const result = []

      const getTypePix = (type) => {
        switch (type) {
          case 'cpf':
            return '<strong>CPF: </strong>'
          case 'evp':
            return '<strong>Chave aleatória: </strong>'
          case 'email':
            return '<strong>E-mail: </strong>'
          case 'phone':
            return '<strong>Celular: </strong>'
          default:
            return '<strong>Chave PIX: </strong>'
        }
      }

      const getBankName = (bank, verified) => {
        if (bank && bank.name && verified !== 3) {
          return ` <br/> ${bank.name}`
        }
        return ''
      }

      data.forEach((element) => {
        let subtext1 = `${getTypePix(element?.pix_type)} ${
          element.pix_key
        } ${getBankName(element?.bank, element?.verified)}`

        result.push({
          name: 'PIX',
          color: { color: '$supportdark' },
          logged: true,
          text: element.owner_full_name,
          subtext1,
          data: element,
        })
      })

      this.pixKeysAccount = result
    },

    async getOwnerPixKeys() {
      const logonToken = this.$store.state.app.logonToken
      const walletApi = new WalletApi(logonToken)
      const response = await walletApi.getAccountPix()

      if (response.data.data) {
        this.listPixKeys = response.data.data
        this.getUserPixKeys(response.data.data)
      }
    },

    focusInWithdrawalTimeInfo() {
      this.$refs.withdrawalTime.classList.remove('shake-element')
      setTimeout(() => {
        this.$refs.withdrawalTime.classList.add('shake-element')
        this.$scrollTo(this.$refs.withdrawalTime, {
          offset: -200,
          duration: 300,
        })
      }, 250)
    },

    isTimeBetween10amAnd6pm() {
      if (this.allowInternalWithdraw) return true

      const options = {
        timeZone: 'America/Sao_Paulo',
        hour12: false,
        hour: 'numeric',
      }
      const formatter = new Intl.DateTimeFormat('pt-BR', options)
      const currentHour = formatter.format(new Date())

      return currentHour >= 10 && currentHour < 18
    },

    withdrawWithPix(data) {
      if (data.verified === 3) {
        this.$refs.modalPixKeyInvalid.open()
        return
      }

      if (
        data.enabled_to_use != 1 ||
        (data.verified != 1 && data.verified != 2)
      ) {
        return this.redirectToValidationInfo(data, data.verified)
      }

      if (!this.isTimeBetween10amAnd6pm()) {
        return this.focusInWithdrawalTimeInfo()
      }

      return this.redirectToWithdraw(data)
    },

    redirectToWithdraw(data) {
      if (!this.btnWidthdrawNotAvailable) {
        this.userDataTransfer = data

        this.$router.push({
          name: 'carteira-saque-pix',
          params: { transfer: this.$route.params.transfer },
        })
      }
    },

    redirectToValidationInfo(data, verified_account) {
      const formated = data.enabled_to_use_at.split(' ')

      const resul = formated[0].split('-')
      this.dateFormated = resul[2] + '/' + resul[1] + '/' + resul[0]

      this.$router.push({
        name: 'carteira-validacao-pix',
        params: {
          id: data.id,
          verified: verified_account,
          enabled_to_use: data.enabled_to_use,
          enabled_to_use_at: data.enabled_to_use_at,
          email: this.wedSiteInfo.site_email,
          data: this.dateFormated,
          from: 'carteira-cadastro-pix',
        },
      })
    },
  },
}
</script>

<style lang="scss">
.layout {
  overflow: hidden;
}

@keyframes shake {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(5px);
  }
  50% {
    transform: translateY(-5px);
  }
  75% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0);
  }
}

.shake-element {
  animation: shake 0.5s 2;
}

.wallet-withdraw {
  display: flex;
  padding: 10px 20px;

  &__msg {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    align-items: center;
    padding: 19px;
    border-radius: 8px;
    border: solid 1px $gray-4;

    p {
      margin-left: 8px;
      font-size: 14px;
    }
  }

  &__transfer-pix {
    padding: 35px 0;
  }

  &__title {
    font-size: 24px;
    font-weight: bold;
    color: $gray-7;
    padding-bottom: 20px;

    @media (max-width: $tablet) {
      padding-bottom: 16px;
    }
  }

  &__subtitle {
    font-size: 16px;
    color: $gray-5;
    padding-bottom: 15px;
    max-width: 80%;
    margin: 0 auto;

    @media (max-width: $tablet) {
      padding-bottom: 16px;
    }
  }

  &__info-title {
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.25;
    color: #5b6674;
    text-align: left;
    padding-bottom: 8px;
  }

  &__info-box {
    margin-bottom: 24px;

    p {
      color: #5b6674;
      font-family: Lato;
      font-size: 16px;

      span {
        color: #048a8b;
        font-weight: bold;
      }
    }

    &--time {
      padding: 16px;
      border-radius: 8px;
      border: solid 1px #aedfe6;
      background-color: #f5fdfe;
      font-family: Lato;
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 23px;

      .title {
        margin-bottom: 4px;
        font-size: 18px;
        font-weight: bold;
        color: $supportdark;
        line-height: normal;
      }

      .attention {
        margin-top: 16px;
      }

      p {
        color: #5b6674;
        padding-left: 8px;
        text-align: left;

        strong {
          color: #5b6674;
        }

        span {
          color: #048a8b;
          font-weight: bold;
        }
      }

      @media (max-width: $tablet) {
        margin-bottom: 16px;
      }
    }

    &--alert {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 16px;

      p {
        margin-left: 10px;
      }
    }

    @media (max-width: $tablet) {
      margin-bottom: 16px;
    }
  }
}

.accounts-registered {
  &--item {
    cursor: pointer;
  }

  .disabled {
    cursor: not-allowed;
    opacity: 0.5;

    .wallet-withdraw {
      &__box {
        background-color: #f7fafb;

        &:hover {
          box-shadow: none;
        }
      }
    }
  }
}

@media (max-width: $tablet) {
  hr {
    margin: 16px 0;
  }
}
</style>
